import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useParams } from "react-router-dom";
import { PostPageViewsTodoList_ItemOrDirectChildUpdatedDocument, ItemType, usePostPageViewsTodoListQuery } from "sprout-graphql";
import { Glitch, NotFound } from "@sprout/views";
import useLoadingProgress from "@sprout/hooks/dist/useLoadingProgress";
import Head from "@sprout/client-layout/dist/Head";
import { getReadableDescription } from "sprout-lib";
import FeatureFlaggedSubscription from "@sprout/client-lib/dist/FeatureFlaggedSubscription";
import TrackJumpHistory from "@sprout/client-components/dist/TrackJumpHistory";
import PostPagePage from "../PostPagePage";
import PostPageViewsTodoListMain from "./PostPageViewsTodoListMain";
import PostPageViewsTodoListToolbar from "./PostPageViewsTodoListToolbar";
const PostPageViewsTodoList = ()=>{
    const { todoListId  } = useParams();
    const { loading , data , error  } = usePostPageViewsTodoListQuery({
        variables: {
            todoListId: Number(todoListId)
        },
        fetchPolicy: "cache-and-network",
        nextFetchPolicy: "cache-first"
    });
    const todoList = data === null || data === void 0 ? void 0 : data.todoList;
    const isInitialLoad = loading && !todoList;
    useLoadingProgress(isInitialLoad);
    if (loading && !todoList) return null;
    if (error) return /*#__PURE__*/ _jsx(Glitch, {
        error: error
    });
    if (!todoList || todoList.type !== ItemType.Checklist) return /*#__PURE__*/ _jsx(NotFound, {});
    const { description , parentTopicId  } = todoList;
    const goBackURL = `/post/${parentTopicId}`;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(TrackJumpHistory, {
                type: ItemType.Checklist,
                data: {
                    itemId: todoList.id
                }
            }),
            /*#__PURE__*/ _jsx(FeatureFlaggedSubscription, {
                subscription: PostPageViewsTodoList_ItemOrDirectChildUpdatedDocument,
                variables: {
                    todoListId: todoList.id
                }
            }),
            /*#__PURE__*/ _jsx(Head, {
                title: description ? `${getReadableDescription(description)} | Sprout` : "Sprout"
            }),
            /*#__PURE__*/ _jsx(PostPagePage, {
                goBackURL: goBackURL,
                item: todoList,
                main: /*#__PURE__*/ _jsx(PostPageViewsTodoListMain, {
                    todoList: todoList
                }),
                toolbar: /*#__PURE__*/ _jsx(PostPageViewsTodoListToolbar, {
                    todoList: todoList
                })
            })
        ]
    });
};
export default PostPageViewsTodoList;
